export default "__VITE_ASSET__BoHPxxXV__"